import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import FullTextField from "../commonControls/FullTextField";
import { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  meRoute,
  resendInvitationRoute,
  signUpRoute,
  verifyAndUpdateRoute,
} from "../../routes/apiRoutes";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { dashboardRoute, selectPlanRoute } from "../../routes/reactRoutes";
import { Phone } from "../commonControls/Phone";
import { PhoneNumberUtil } from "google-libphonenumber";
import Loading from "../commonControls/loading";
import UnAuthorized from "../commonControls/UnAuthorized";
import { login } from "../../Redux/authenticationSlice";
import { LogoAndText } from "../../theme/JaziTheme";
import { ThumbUp } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link } from "react-router-dom";
import axiosInstance from "../../axios/axiosInstance";
import { t } from "i18next";
import FlipLanguageSwitcher from "./FlipLanguageSwitcher";

const RegisterSimple = (props) => {
  const theme = useTheme();
  const [codeVerified, setCodeVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState({
    password: false,
    confirmPassword: false,
  });
  const dispatch = useDispatch();
  const [code, setCode] = useState("");
  const [reqFailed, setReqFailed] = useState(false);
  const [expired, setExpired] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);
  const [newTokenSent, setNewTokenSent] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [timeExpiring, setTimeExpiring] = useState(false);
  const [phoneValue, setPhoneValue] = useState("+974");
  const [phoneError, setPhoneError] = useState(false);
  const phoneUtil = PhoneNumberUtil.getInstance();
  const navigate = useNavigate();
  useEffect(() => {
    document.title = props.title;
    const checkCode = async () => {
      try {
        const params = new URLSearchParams(document.location.search);
        const inputCode = params.get("code");
        setCode(inputCode);
        const { data } = await axiosInstance.get(`${signUpRoute}/${inputCode}`);
        if (data) {
          if (data.statusCode === 200 || data.statusCode === 201) {
            setCodeVerified(true);
            setExpired(false);
            formik.setFieldValue("firstName", data.response?.firstName);
            formik.setFieldValue("lastName", data.response?.lastName);
            data.response?.phoneNo && setPhoneValue(data.response?.phoneNo);
            const expiryTime = new Date(data.response?.exipryTime);
            const currentTime = new Date();
            const remainingSeconds =
              (expiryTime.getTime() - currentTime.getTime()) / 1000;
            handleTimer(remainingSeconds.toFixed(0));
          } else {
            toast.dismiss();
            toast.error(t("unexpectedserverresponse"), {
              autoClose: false,
            });
            setReqFailed(true);
          }
        }
      } catch (error) {
        if (error.response?.data?.message === "Invite code is expired") {
          setCodeVerified(true);
          setExpired(true);
        } else if(error.response?.data?.statusCode === 400) {
          toast.dismiss();
          toast.error(t("invalidInvite"), { autoClose: false });
          setReqFailed(true);
        } else if(error.response?.data?.statusCode === 404) {
          toast.dismiss();
          toast.error(error.response?.data?.message, {
            autoClose: false,
          });
          setReqFailed(true);
        }
        else if(error.response?.data?.statusCode === 409) {
          toast.dismiss();
          toast.error(error.response?.data?.message, {
            autoClose: false,
          });
          setReqFailed(true);
        }
        else {
          toast.dismiss();
          toast.error(t("verifyerror"), {
            autoClose: false,
          });
          setReqFailed(true);
        }
      }
    };
    checkCode();
    if (localStorage.getItem("token")) handleToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handlePhoneNumberChange = (value) => {
    setPhoneValue(value);

    // Extract country code from value (e.g., "+92" or "+974")
    const countryCodeMatch = value.match(/^\+(\d{1,3})/);
    const countryCode = countryCodeMatch ? countryCodeMatch[0] : "";

    // Check if value is empty or only contains country code
    const hasPhoneNumber = value.length > countryCode.length;

    // Only validate if there's actual phone number input
    if (hasPhoneNumber) {
      setPhoneError(!isPhoneValid(value));
    } else {
      // Clear error if only country code is present
      setPhoneError(false);
    }

    // Update Formik value only if there's actual phone number
    formik.setFieldValue("phoneNo", hasPhoneNumber ? value : "");
  };

  const handleTimer = async (remainingSeconds) => {
    let i = remainingSeconds;
    const interval = setInterval(() => {
      if (i < 200 && i > 0) {
        setTimeExpiring(true);
      } else if (i < 1) {
        clearInterval(interval);
        window.location.reload();
      }
      setRemainingTime(i);
      i--;
    }, 1000);
  };

  const handleToken = async () => {
    try {
      const { data } = await axiosInstance.get(meRoute, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (data.statusCode === 200 || data.statusCode === 201) {
        dispatch(
          login({
            user: data.response,
            token: null,
            avatar: localStorage.getItem("avatar"),
            subscriptionStatus: data.response.subscriptionStatus,
          })
        );
        setLoggedIn(true);
      }
    } catch {
      //
    }
  };
  const isPhoneValid = (phone) => {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
      return false;
    }
  };
  const handlePasswordVisibility = (field) => {
    if (field === "password") {
      setPasswordVisible((prevState) => {
        return { ...prevState, password: !prevState.password };
      });
    } else if (field === "confirmPassword") {
      setPasswordVisible((prevState) => {
        return { ...prevState, confirmPassword: !prevState.confirmPassword };
      });
    }
  };
  const schema = yup.object({
    password: yup
      .string()
      .min(8, t("passwordyupmin"))
      .max(20, t("passwordyupmax"))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&]).{8,}$/,
        t("passwordyup")
      )
      .required(t("passwordisrequired")),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], t("confirmpasswordsame"))
      .required(t("confirmpasswordrequired")),
    firstName: yup
      .string()
      .trim()
      .min(1, t("spacenotallowed"))
      .required(t("firstnamerequired")),
    lastName: yup
      .string()
      .trim()
      .min(1, t("spacenotallowed"))
      .required(t("lastnamerequired")),
    phoneNo: yup
      .string()
      .test("Phone number Validity", t("phoneinvalid"), () => !phoneError),
  });
  const schemaToken = yup.object({
    inviteEmail: yup
      .string()
      .email(t("emailinvalid"))
      .required(t("emailisrequired")),
  });

  const formik = useFormik({
    initialValues: {
      password: undefined,
      phoneNo: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        // filter empty values
        const inputData = Object.fromEntries(
          Object.entries(values).filter(
            ([key, value]) => value !== "" && key !== "confirmPassword"
          )
        );
        // Post signup data to server
        const { data } = await axiosInstance.post(verifyAndUpdateRoute, {
          ...inputData,
          code: code,
        });

        if (data.statusCode === 200 || data.statusCode === 201) {
          toast.dismiss();
          toast.success(
            t("userregistered", { name: data?.response?.user?.firstName }),
            { autoClose: 1000 }
          );
          dispatch(
            login({
              user: data.response.user,
              token: data.response.accessToken,
              subscriptionStatus: data.response.user?.subscriptionStatus,
            })
          );
          formik.resetForm();
          setLoading(false);
          if (data.response.user?.subscriptionStatus) {
            navigate(dashboardRoute);
          } else {
            navigate(selectPlanRoute);
          }
        } else {
          toast.dismiss();
          setLoading(false);
          toast.error(t("unexpectedserverresponse"), {
            autoClose: false,
          });
        }
      } catch (error) {
        if (error.response?.data?.message === "Invite code is expired") {
          setCodeVerified(true);
          setExpired(true);
        } else if (error.response?.data?.statusCode === 409) {
          toast.dismiss();
          toast.error(t("registerduplicateerror"), { autoClose: false });
        } else {
          toast.dismiss();
          setLoading(false);
          toast.error(t("registererror"), {
            autoClose: false,
          });
        }
      } finally {
        setLoading(false);
      }
    },
  });

  const formikToken = useFormik({
    initialValues: {
      inviteEmail: "",
    },
    validationSchema: schemaToken,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const { data } = await axiosInstance.get(
          `${resendInvitationRoute}${values.inviteEmail}`
        );
        if (data.statusCode === 200 || data.statusCode === 201) {
          toast.dismiss();
          setNewTokenSent(true);
          toast.success(t("newemailsent"), { autoClose: false });
          formikToken.resetForm();
          setLoading(false);
        } else {
          toast.dismiss();
          setLoading(false);
          toast.error(t("registeremailsenderror"), {
            autoClose: false,
          });
        }
      } catch (error) {
        if (error.response?.data?.message === "User dont have pending invite") {
          formikToken.setFieldError("inviteEmail", t("wrongregisteremail"));
        } else {
          toast.dismiss();
          toast.error(t("registeremailsenderror"), {
            autoClose: false,
          });
          formikToken.resetForm();
          setReqFailed(true);
        }
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    Object.keys(formik.touched).forEach((field) => {
      try {
        formik.validateField(field);
      } catch {}
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme.direction]);

  const outerBox = {
    background: theme.palette.whiteblack.main,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    //border: `0.5px solid ${theme.palette.componentBackgrounds.main}`,
    borderRadius: 1,
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
    py: 5,
    px: 2,
    maxWidth: 500,
    maxHeight: 600,
    width: "100%",
    height: "100vh",
  };
  const outerBoxBanner = {
    background: theme.palette.whiteblack.main,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 0,
    maxWidth: 500,
    px: 2,
    mb: 1,
    py: 0,
    maxHeight: 50,
    width: "100%",
    height: "100vh",
  };
  const outerBoxToken = {
    background: theme.palette.whiteblack.main,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: `0.5px solid ${theme.palette.componentBackgrounds.main}`,
    borderRadius: 0,
    py: 7,
    px: 2,
    maxWidth: 500,
    maxHeight: 250,
    width: "100%",
    height: "100vh",
  };
  const formStyle2 = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "90%",
    height: "100%",
    justifyContent: "space-between",
  };
  const rootStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: window.innerHeight > 820 ? "100vh" : 820,
    margin: 0,
    background: theme.palette.primary.main,
    backgroundImage: "url('/background.webp')",
    backgroundSize: "cover",
  };
  const formStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minWidth: "90%",
    gap: 2.5,
  };
  const textFieldStyle = {
    background: theme.palette.componentBackgrounds.new,
    width: "100%",
    my: 1.75,
    border: "none",
    height: 38,
  };

  return codeVerified && !expired ? (
    <div dir={theme.direction} style={rootStyle}>
      {(loggedIn || timeExpiring) && (
        <Paper elevation={2} sx={outerBoxBanner}>
          {!loggedIn ? (
            <Box
              width={"100%"}
              height={50}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: "1.2rem", fontWeight: 400 }}>
                {t("invitationexpiresin")}{" "}
                <span
                  style={{ fontWeight: 600, color: theme.palette.primary.main }}
                >{`${remainingTime > 0 ? remainingTime : 0}`}</span>{" "}
                {t("seconds")}
              </Typography>
            </Box>
          ) : (
            <Box
              width={"100%"}
              height={50}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Typography sx={{ fontSize: "1.2rem", fontWeight: 600 }}>
                {t("alreadyloggedin")}
              </Typography>
              <Link
                to={dashboardRoute}
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 400,
                  marginTop: -5,
                }}
              >
                {t("gohome")}
              </Link>
            </Box>
          )}
        </Paper>
      )}
      <Paper elevation={0} sx={outerBox}>
        <Box
          sx={{ display: "flex", justifyContent: "center", mb: 2, zoom: 0.8 }}
        >
          <LogoAndText />
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "90%",
            alignItems: "center",
            textAlign: "left",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.125rem",
              fontWeight: 500,
              textAlign: "left",
              alignSelf: "center",
              flexGrow: 1,
            }}
          >
            {t("welcomeUser")}
          </Typography>

          <FlipLanguageSwitcher />
        </Box>
        <Box sx={{ display: "flex", width: "90%", textAlign: "left", mb: 3 }}>
          <Typography
            sx={{
              fontSize: "1.25rem",
              fontWeight: 800,
              textAlign: "left",
              flexGrow: 1,
            }}
          >
            {t("createAccount")}
          </Typography>
        </Box>
        <form style={formStyle2} onSubmit={formik.handleSubmit}>
          <FullTextField
            id="profile-first-name-field"
            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
            value={formik.values.firstName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name="firstName"
            type="text"
            title={t("firstname")}
          />
          <FullTextField
            id="profile-last-name-field"
            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
            value={formik.values.lastName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name="lastName"
            type="text"
            title={t("lastname")}
          />
          <TextField
            id="profile-new-password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            name="password"
            label={t("newpassword")+"*"}
            type={!passwordVisible.password ? "password" : "text"}
            sx={textFieldStyle}
            size="small"
            placeholder={t("newpassword")+"*"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    tabIndex={-1}
                    aria-label="toggle password visibility"
                    onClick={() => handlePasswordVisibility("password")}
                    edge="end"
                  >
                    {passwordVisible.password ? (
                      <VisibilityOff />
                    ) : (
                      <Visibility />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            id="profile-confirm-password"
            error={
              formik.touched.confirmPassword &&
              Boolean(formik.errors.confirmPassword)
            }
            helperText={
              formik.touched.confirmPassword && formik.errors.confirmPassword
            }
            value={formik.values.confirmPassword}
            size="small"
            label={t("confirmpassword")+"*"}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name="confirmPassword"
            sx={textFieldStyle}
            type={!passwordVisible.confirmPassword ? "password" : "text"}
            placeholder={t("confirmpassword")+"*"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    tabIndex={-1}
                    aria-label="toggle confirm password visibility"
                    onClick={() => handlePasswordVisibility("confirmPassword")}
                    edge="end"
                  >
                    {passwordVisible.confirmPassword ? (
                      <VisibilityOff />
                    ) : (
                      <Visibility />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
           <Phone
            onChange={handlePhoneNumberChange}
            id="profile-phone-field"
            value={phoneValue}
            name="phoneNo"
            error={phoneError}
            type="tel"
            helperText={phoneError ? t("phoneinvalid") : null}
          ></Phone>
          <LoadingButton
            type="submit"
            loading={loading}
            disabled={loggedIn}
            variant="contained"
            endIcon={<ThumbUp />}
            sx={{
              width: "100%",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "1rem",
              my: 2.5,
              py: 1.5,
            }}
          >
            <span>{t("letsbegin")}</span>
          </LoadingButton>
        </form>
      </Paper>
    </div>
  ) : expired && !reqFailed ? (
    <div
      dir={theme.direction}
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        background: alpha(theme.palette.primary.main, 0.15),
      }}
    >
      <Paper elevation={1} sx={outerBoxToken}>
        <Box
          sx={{ display: "flex", justifyContent: "center", mb: 2, zoom: 0.8 }}
        >
          <LogoAndText />
        </Box>
        <Box sx={{ display: "flex", width: "90%", textAlign: "left", mb: 0 }}>
          <Typography
            sx={{
              fontSize: "1.25rem",
              fontWeight: 800,
              textAlign: "left",
              flexGrow: 1,
            }}
          >
            {t("invitationExpired")}
          </Typography>
          <FlipLanguageSwitcher />
        </Box>
        <form style={formStyle2} onSubmit={formikToken.handleSubmit}>
          <Box sx={{ ...formStyle, width: "100%" }}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                mt: 4.6,
                flex: 1,
                alignItems: "center",
              }}
            >
              <FullTextField
                id="invite-email"
                value={formikToken.values.inviteEmail}
                onChange={formikToken.handleChange}
                onBlur={formikToken.handleBlur}
                error={
                  formikToken.touched.inviteEmail &&
                  Boolean(formikToken.errors.inviteEmail)
                }
                helperText={
                  formikToken.touched.inviteEmail &&
                  formikToken.errors.inviteEmail
                }
                name="inviteEmail"
                title={t("invitationEmail")}
              />
            </Box>
          </Box>
          <Box sx={{ width: "100%" }}>
            <LoadingButton
              type="submit"
              loading={loading}
              disabled={newTokenSent}
              variant="contained"
              sx={{
                width: "100%",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "1rem",
                my: 2.5,
                py: 1.5,
              }}
            >
              <span>{t("requestNewInvitation")}</span>
            </LoadingButton>
          </Box>
        </form>
      </Paper>
    </div>
  ) : (
    <Box sx={{ width: "100%", height: "100vh" }}>
      {!reqFailed ? <Loading /> : <UnAuthorized />}
    </Box>
  );
};
export default RegisterSimple;
